import { useState, type FormEvent } from 'react'
import { PasswordInput } from '@alascorporation/ui'
import { changePassword } from '../../lib/api'

export function SecuritySection() {
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [errorField, setErrorField] = useState<'current' | 'new' | 'confirm' | null>(null)
  const [success, setSuccess] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    if (isSubmitting) return
    setError(null)
    setErrorField(null)
    setSuccess(false)

    if (newPassword.length < 8) {
      setError('La nueva contraseña debe tener al menos 8 caracteres.')
      setErrorField('new')
      return
    }
    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden.')
      setErrorField('confirm')
      return
    }

    setIsSubmitting(true)
    try {
      await changePassword(currentPassword, newPassword)
      setSuccess(true)
      setCurrentPassword('')
      setNewPassword('')
      setConfirmPassword('')
    } catch {
      setError('No se pudo cambiar la contraseña. Verifica tu contraseña actual.')
      setErrorField('current')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <section>
      <p className="account-section__eyebrow">SateLab</p>
      <h1 className="account-section__title">Seguridad</h1>
      <p className="account-section__subtitle">Cambia la contraseña de tu cuenta.</p>

      <div className="account-section__body">
        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="auth-label" htmlFor="current-password">
            Contraseña actual
          </label>
          <PasswordInput
            id="current-password"
            className="auth-input"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
            aria-invalid={errorField === 'current'}
            aria-describedby={errorField === 'current' ? 'security-error' : undefined}
          />

          <label className="auth-label" htmlFor="new-password">
            Nueva contraseña
          </label>
          <PasswordInput
            id="new-password"
            className="auth-input"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            minLength={8}
            required
            aria-invalid={errorField === 'new'}
            aria-describedby={errorField === 'new' ? 'security-error' : undefined}
          />

          <label className="auth-label" htmlFor="confirm-password">
            Confirmar nueva contraseña
          </label>
          <PasswordInput
            id="confirm-password"
            className="auth-input"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            minLength={8}
            required
            aria-invalid={errorField === 'confirm'}
            aria-describedby={errorField === 'confirm' ? 'security-error' : undefined}
          />

          {error && (
            <p className="auth-error" role="alert" id="security-error">
              {error}
            </p>
          )}
          {success && (
            <p className="account-success" role="status">
              Contraseña actualizada correctamente.
            </p>
          )}

          <button type="submit" className="auth-button" disabled={isSubmitting}>
            {isSubmitting ? 'Guardando…' : 'Cambiar contraseña'}
          </button>
        </form>
      </div>
    </section>
  )
}
